import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
const POINTS = ['Pago único con Mercado Pago, sin suscripción', 'Acceso inmediato vía mail a todo el material', 'Acceso a la comunidad de clientes VIP', 'Garantía de devolución dentro de los 10 días'];
export function FinalOffer() {
  return <Section className="bg-cream-50" data-id="element-148" data-mp="1cgwky1s51bw9">
      <div className="rounded-[2rem] border border-ink-950/10 bg-ink-950 p-7 text-center sm:p-10" data-id="element-149" data-mp="1qe1sk67i2itm">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-150" data-mp="1lg9z37r7ionb">
          Paquete completo
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-151" data-mp="203349k70ie1s">
          Libro principal + 5 bonos de regalo
        </h2>

        <p className="mt-8 text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-152" data-mp="294t5fhqp4rcr">
          $33.999 ARS
        </p>
        <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-white/50" data-id="element-153" data-mp="24715c0fwdyxh">
          Pago único · Acceso de por vida
        </p>

        <div className="mt-8" data-id="element-154" data-mp="1rjjmr48bcio">
          <CTAButton className="items-center" data-id="element-155" data-mp="6o09pquzo0ye" />
        </div>

        <ul className="mx-auto mt-8 grid max-w-2xl gap-3 text-left sm:grid-cols-2" data-id="element-156" data-mp="6qmifttm8mi7">
          {POINTS.map(point => <li key={point} className="flex items-start gap-3 text-sm leading-relaxed text-white/70" data-id="element-157" data-mp="bpzen56dn5xg">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-158" data-mp="gkd46qycyiu7" />
              {point}
            </li>)}
        </ul>
      </div>
    </Section>;
}